var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',_vm._g(_vm._b({},'wrap',_vm.$props,false),_vm.$listeners),[(_vm.chart)?_c('chart-component',{attrs:{"chart":_vm.chart,"record":_vm.record,"reporter":_vm.reporter}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }